"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _uploader = _interopRequireDefault(require("./uploader"));

var _index = require("./utils/index");

var _compact_props = _interopRequireDefault(require("./utils/compact_props"));

var _no_value_component = _interopRequireDefault(require("./component/mediauploader/no_value_component"));

var _status_component = _interopRequireDefault(require("./component/mediauploader/status_component"));

var _display_component = _interopRequireDefault(require("./component/mediauploader/display_component"));

var _icon_plus_component = _interopRequireDefault(require("./component/mediauploader/icon_plus_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isFunction = _spauiUtils.utils.isFunction,
    getVersion = _spauiUtils.utils.getVersion;
/**
 * @class
 */

var MediaUploader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MediaUploader, _PureComponent);

  /**
   * 属性说明
   * @alias MediaUploaderProps
   * @description 媒体上传组件
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {bool} [disabled=false] 是否禁用
   * @property {bool} [multiple=false] 是否多选
   * @property {string} [fileId] 指定"input type=file"的id
   * @property {bool} [autoUpload=true] 是否自动上传
   * @property {string} [title=''] 空的时候的文案提示
   * @property {string} [description] 空的时候的内容备注
   * @property {string} [accept='*'] 选择的文件类型
   * @property {func} [onFileChange] 文件变化即调用<br />onFileChange(event, isDrag, imageIndex, files)
   * @property {titleline} 已上传数据属性
   * @property {object} [value={}] 已经上传的数据<br />value={url, name, status}
   * @property {bool} [canDelete=true] 是否支持删除
   * @property {func} [onPreview] 成功上传默认操作位置预览回调<br />onPreview(event)
   * @property {func} [onDelete] 数据删除回调<br />onDelete(event)
   * @property {titleline} 触发上传属性
   * @property {string} [name=''] 字段名
   * @property {string} [url=''] 上传的url
   * @property {func} [setUrl] 动态设置上传的url
   * @property {object|function} [data={}] 接口附带的数据
   * @property {boolean} [retry=false] 是否支持失败后点击重试上传
   * @property {object} [headers={}] 请求header参数
   * @property {number} [uploadPoolSize] 并发上传池大小。
   * @property {string} [type=''] 上传类型,type=video为上传的是视频，其他为图片
   * @property {func} [filter] 筛选文件（只适用于支持html5的）<br />filter(fileInfo, event)
   * @property {func} [check] 异步文件检查成功后，调用next继续上传<br />check(fileInfo, next, files) 检查成功后，调用next继续上传
   * @property {func} [canUpload] 是否能够触发上传<br />canUpload(event)
   * @property {func} [onUpload] 开始上传回调<br />onUpload(event, fileInfo)
   * @property {func} [onProgress] 上传过程回调<br />onProgress(progressEvent, fileInfo)
   * @property {func} [onComplete] 上传完成回调<br />onComplete(resp, fileInfo, inputFileId, xhr)
   * @property {titleline} 自定义属性
   * @property {func|element} [StatusComponent] 文件上传显示结构*(具体参数看案例)*
   * @property {func|element} [ActionComponent] 操作Component*(具体参数看案例)*
   * @property {object} [ActionComponentProps = {}] ActionComponent的附加props
   * @property {func|element} [FooterComponent] 尾部Component*(具体参数看案例)*
   * @property {object} [FooterComponentProps = {}] FooterComponent的附加props
   * @property {func|element} [DisplayComponent] 展示Component*(具体参数看案例)*
   * @property {func|element} [IconPlusComponent] 展示Component*(具体参数看案例)*
   * @example
   * &lt;StatusComponent
   DisplayComponent={DisplayComponent}
   value={value}
   status={status}
   progress={progress}
   setUploader={this.setUploader}
   onDelete={this.handleDelete}
   deleteable={canDelete}
   canDelete={canDelete}
   ActionComponent={ActionComponent}
   FooterComponent={FooterComponent}
   triggerUpload={this.triggerUpload}
  /&gt;
   *
   * &lt;ActionComponent className='spaui-upmedia-action' triggerUpload={triggerUpload} value={value} /&gt;
   * &lt;FooterComponent className='spaui-upmedia-footer' value={value} /&gt;
   *
   * &lt;DisplayComponent
      type={type}
      data={data}
      controls={controls}
  /&gt;
   */
  function MediaUploader(props) {
    var _this;

    _classCallCheck(this, MediaUploader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaUploader).call(this, props));

    _this.refList();

    _this.handleUpload = _this.handleUpload.bind(_assertThisInitialized(_this));
    _this.handleProgress = _this.handleProgress.bind(_assertThisInitialized(_this));
    _this.handleComplete = _this.handleComplete.bind(_assertThisInitialized(_this));
    _this.handleDelete = _this.handleDelete.bind(_assertThisInitialized(_this));
    _this.setUploader = _this.setUploader.bind(_assertThisInitialized(_this));
    _this.triggerUpload = _this.triggerUpload.bind(_assertThisInitialized(_this));
    _this.id = (0, _index.uniqueId)();
    _this.emptyId = "".concat(_this.id, "-empty");
    _this.statusId = "".concat(_this.id, "-status");
    _this.instanceId = "".concat((0, _index.uniqueId)(), "-mediauploader");
    var _props$value = props.value,
        value = _props$value === void 0 ? {} : _props$value;
    _this.state = {
      status: value.status || '',
      progress: value.progress || 0
    };
    return _this;
  }

  _createClass(MediaUploader, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _nextProps$value = nextProps.value,
          value = _nextProps$value === void 0 ? {} : _nextProps$value;

      if ((0, _index.isEmptyObject)(value)) {
        this.setState({
          status: '',
          progress: 0
        });
      } else {
        if (typeof value.status !== 'undefined') {
          this.setState({
            status: value.status
          });
        }

        if (typeof value.progress !== 'undefined') {
          this.setState({
            progress: value.progress
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refList();
    }
  }, {
    key: "refList",
    value: function refList() {
      this.domRef = null;
      this.uploadRef = null;
    }
  }, {
    key: "triggerUpload",
    value: function triggerUpload() {
      if (this.uploadRef && this.uploadRef.inputRef) {
        this.uploadRef.inputRef.click();
      }
    } // 开始上传

  }, {
    key: "handleUpload",
    value: function handleUpload(event, fileInfo) {
      var _this$props = this.props,
          onUpload = _this$props.onUpload,
          autoUpload = _this$props.autoUpload;
      var infoData = {
        name: fileInfo.name || '文件上传中...',
        status: 'ready',
        progress: 0
      };

      if (autoUpload) {
        this.setState(infoData);
      }

      if (isFunction(onUpload)) {
        onUpload(event, fileInfo);
      }
    } // 进度

  }, {
    key: "handleProgress",
    value: function handleProgress(event, item) {
      var onProgress = this.props.onProgress;
      this.setState({
        status: 'uploading',
        progress: event.loaded / event.total * 100
      });

      if (isFunction(onProgress)) {
        onProgress(event, item);
      }
    } // 上传完成

  }, {
    key: "handleComplete",
    value: function handleComplete(err, xhr) {
      var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var fileTarget = arguments.length > 3 ? arguments[3] : undefined;
      var fileId = arguments.length > 4 ? arguments[4] : undefined;
      var onComplete = this.props.onComplete;
      this.setState({
        progress: 100
      });

      if (isFunction(onComplete)) {
        onComplete(resp, fileTarget, fileId, xhr);
      }
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(event) {
      var _this$props2 = this.props,
          onDelete = _this$props2.onDelete,
          autoUpload = _this$props2.autoUpload;

      if (autoUpload) {
        this.setState({
          status: '',
          progress: 0
        });
        this.abort();
      }

      if (isFunction(onDelete)) {
        onDelete(event);
      }

      event.stopPropagation();
    } // 获取input type='file'

  }, {
    key: "getInputDOMNode",
    value: function getInputDOMNode() {
      var result = null;

      if (this.uploadRef) {
        result = this.uploadRef.getInputDOMNode();
      }

      return result;
    } // 对外使用可以进行上传

  }, {
    key: "startUpload",
    value: function startUpload() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var headers = arguments.length > 1 ? arguments[1] : undefined;
      var customFiles = arguments.length > 2 ? arguments[2] : undefined;

      if (this.uploadRef) {
        this.uploadRef.startUpload(data, headers, customFiles);
      }
    } // 对外使用可以进行上传

  }, {
    key: "abort",
    value: function abort() {
      if (this.uploadRef && isFunction(this.uploadRef.abort)) {
        this.uploadRef.abort();
      }
    } // 设置上传

  }, {
    key: "setUploader",
    value: function setUploader(children, config) {
      var _this2 = this;

      var _this$props3 = this.props,
          name = _this$props3.name,
          url = _this$props3.url,
          multiple = _this$props3.multiple,
          disabled = _this$props3.disabled,
          filter = _this$props3.filter,
          canUpload = _this$props3.canUpload,
          autoUpload = _this$props3.autoUpload,
          data = _this$props3.data,
          click = _this$props3.click,
          accept = _this$props3.accept,
          onFileChange = _this$props3.onFileChange,
          check = _this$props3.check,
          fileId = _this$props3.fileId,
          headers = _this$props3.headers,
          _this$props3$FileAPIC = _this$props3.FileAPIConfig,
          FileAPIConfig = _this$props3$FileAPIC === void 0 ? {} : _this$props3$FileAPIC,
          unmountInactiveInput = _this$props3.unmountInactiveInput,
          _this$props3$abortTri = _this$props3.abortTriggerComplete,
          abortTriggerComplete = _this$props3$abortTri === void 0 ? false : _this$props3$abortTri,
          setUrl = _this$props3.setUrl,
          uploadPoolSize = _this$props3.uploadPoolSize;
      var props = (0, _spauiUtils.objectAssign)({
        disabled: disabled,
        multiple: multiple,
        drag: false,
        name: name,
        url: url,
        data: data,
        filter: filter,
        click: click,
        accept: accept,
        autoUpload: autoUpload,
        canUpload: canUpload,
        onFileChange: onFileChange,
        onProgress: this.handleProgress,
        onUpload: this.handleUpload,
        onComplete: this.handleComplete,
        abortTriggerComplete: abortTriggerComplete,
        check: check,
        fileId: fileId,
        headers: headers,
        FileAPIConfig: FileAPIConfig,
        unmountInactiveInput: unmountInactiveInput,
        setUrl: setUrl,
        uploadPoolSize: uploadPoolSize
      }, config);
      return _react["default"].createElement(_uploader["default"], _extends({}, props, {
        ref: function ref(el) {
          _this2.uploadRef = el;
        },
        instanceId: this.instanceId
      }), children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          StatusComponent = _this$props4.StatusComponent,
          DisplayComponent = _this$props4.DisplayComponent,
          autoUpload = _this$props4.autoUpload,
          disabled = _this$props4.disabled,
          _this$props4$value = _this$props4.value,
          value = _this$props4$value === void 0 ? {} : _this$props4$value,
          ActionComponent = _this$props4.ActionComponent,
          FooterComponent = _this$props4.FooterComponent,
          title = _this$props4.title,
          description = _this$props4.description,
          IconPlusComponent = _this$props4.IconPlusComponent,
          useNewUI = _this$props4.useNewUI;

      var _compactProps = (0, _compact_props["default"])(this.props),
          canDelete = _compactProps.canDelete;

      var _this$state = this.state,
          progress = _this$state.progress,
          stateStatus = _this$state.status;
      var onlyUrl = value.url && typeof value.status === 'undefined';
      var haveChildren = typeof children !== 'undefined' && children;
      var NoValueComponentProps = {
        id: this.emptyId,
        title: title,
        description: description,
        icon: _react["default"].createElement(IconPlusComponent, null)
      };
      var NoValueComponent = _no_value_component["default"];
      var status = value.status || stateStatus || '';

      if (haveChildren) {
        NoValueComponent = (0, _react.cloneElement)(children, NoValueComponentProps);
      } // value只传了url且status没有状态的话，就当成success来展示


      if (onlyUrl && !status) {
        status = 'success';
      }

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        supportAllEvents: true,
        className: (0, _classnames["default"])('spaui-upmedia', {
          disabled: disabled,
          error: status === 'fail' || status === 'error',
          success: status === 'success',
          ready: status === 'ready',
          uploading: status === 'uploading',
          loading: status === 'loading',
          "default": !status || status === 'default',
          'with-reset': status === 'success' && typeof ActionComponent !== 'undefined',
          'with-addons': status === 'success' && typeof FooterComponent !== 'undefined',
          'spaui-upmedia-ie': getVersion() > 6 && getVersion() < 11,
          'spaui-upmedia-new': useNewUI
        })
      }, MediaUploader, this.props), {
        ref: function ref(el) {
          _this3.domRef = el;
        }
      }), !status ? this.setUploader(haveChildren ? NoValueComponent : _react["default"].createElement(NoValueComponent, NoValueComponentProps)) : _react["default"].createElement(StatusComponent, _extends({}, this.props, {
        DisplayComponent: DisplayComponent,
        value: value,
        status: status,
        progress: progress,
        setUploader: this.setUploader,
        onDelete: this.handleDelete,
        deleteable: canDelete,
        canDelete: canDelete,
        ActionComponent: ActionComponent,
        FooterComponent: FooterComponent,
        triggerUpload: this.triggerUpload
      })), !autoUpload ? _react["default"].createElement(StatusComponent, _extends({}, this.props, {
        DisplayComponent: DisplayComponent,
        value: value,
        id: this.statusId,
        style: {
          display: 'none'
        },
        status: status,
        progress: progress,
        onDelete: this.handleDelete,
        deleteable: canDelete,
        canDelete: canDelete,
        ActionComponent: ActionComponent,
        FooterComponent: FooterComponent,
        triggerUpload: this.triggerUpload
      })) : null);
    }
  }]);

  return MediaUploader;
}(_react.PureComponent);

_defineProperty(MediaUploader, "propTypes", {
  name: _spauiUtils.PropTypes.string,
  url: _spauiUtils.PropTypes.string,
  setUrl: _spauiUtils.PropTypes.func,
  data: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.object]),
  retry: _spauiUtils.PropTypes.bool,
  headers: _spauiUtils.PropTypes.object,
  uploadPoolSize: _spauiUtils.PropTypes.number,
  disabled: _spauiUtils.PropTypes.bool,
  multiple: _spauiUtils.PropTypes.bool,
  accept: _spauiUtils.PropTypes.string,
  filter: _spauiUtils.PropTypes.func,
  check: _spauiUtils.PropTypes.func,
  value: _spauiUtils.PropTypes.object,
  canDelete: _spauiUtils.PropTypes.bool,
  autoUpload: _spauiUtils.PropTypes.bool,
  onUpload: _spauiUtils.PropTypes.func,
  onProgress: _spauiUtils.PropTypes.func,
  onComplete: _spauiUtils.PropTypes.func,
  onPreview: _spauiUtils.PropTypes.func,
  onDelete: _spauiUtils.PropTypes.func,
  onFileChange: _spauiUtils.PropTypes.func,
  title: _spauiUtils.PropTypes.string,
  type: _spauiUtils.PropTypes.string,
  description: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.number, _spauiUtils.PropTypes.object]),
  StatusComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ActionComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  ActionComponentProps: _spauiUtils.PropTypes.object,
  FooterComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  FooterComponentProps: _spauiUtils.PropTypes.object,
  DisplayComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  IconPlusComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  useNewUI: _spauiUtils.PropTypes.bool
});

_defineProperty(MediaUploader, "defaultProps", {
  name: '',
  url: '',
  data: {},
  retry: false,
  headers: {},
  disabled: false,
  multiple: false,
  accept: '*',
  filter: function filter() {
    return true;
  },
  value: {},
  title: '本地上传',
  type: '',
  canDelete: true,
  autoUpload: true,
  StatusComponent: _status_component["default"],
  DisplayComponent: _display_component["default"],
  IconPlusComponent: _icon_plus_component["default"],
  useNewUI: false,
  ActionComponentProps: {},
  FooterComponentProps: {}
});

var _default = MediaUploader;
exports["default"] = _default;